import { useTranslation } from "react-i18next";
import {
  SettingIcon,
  Menu,
  SubMenu,
  MenuItem,
  DiskIcon,
  FormatIcon,
  TextIcon,
  ChartIcon,
} from "melco-ui";
import { useMainMenu } from "melco-shared-logic";

export const MainMenuFusion: React.FC = () => {
  const { t } = useTranslation();
  const { selectedKeys, onClick } = useMainMenu();

  return (
    <Menu
      mode="inline"
      selectedKeys={selectedKeys}
      defaultOpenKeys={selectedKeys}
      onClick={onClick}
    >
      <MenuItem key="/" icon={<ChartIcon />}>
        {t("main_menu.dashboard")}
      </MenuItem>

      <MenuItem key="/orders" icon={<TextIcon />}>
        {t("main_menu.orders")}
      </MenuItem>

      <MenuItem key="/customization/products" icon={<FormatIcon />}>
        {t("main_menu.customization_products")}
      </MenuItem>

      <SubMenu
        key="/libraries"
        icon={<DiskIcon />}
        title={t("main_menu.libraries")}
      >
        <MenuItem key="/libraries/designs">
          {t("main_menu.libraries_designs")}
        </MenuItem>
        <MenuItem key="/libraries/design-collections">
          {t("main_menu.libraries_design_collections")}
        </MenuItem>
        <MenuItem key="/libraries/blanks">
          {t("main_menu.libraries_blanks")}
        </MenuItem>
        <MenuItem key="/libraries/blank-pictures">
          {t("main_menu.libraries_blanks_blank_pictures")}
        </MenuItem>
        <MenuItem key="/libraries/fonts/embroidery">
          {t("main_menu.libraries_fonts_embroidery")}
        </MenuItem>
        <MenuItem key="/libraries/color-collections/embroidery">
          {t("main_menu.libraries_color_collections_embroidery")}
        </MenuItem>
      </SubMenu>

      <SubMenu
        key="/settings"
        icon={<SettingIcon />}
        title={t("main_menu.settings")}
      >
        <MenuItem key="/settings/basic">
          {t("main_menu.settings_basic")}
        </MenuItem>
        <MenuItem key="/settings/configurator">
          {t("main_menu.settings_configurator")}
        </MenuItem>
      </SubMenu>
    </Menu>
  );
};
